/* ATP Part-Type + Shop-by-Truck menus — on-demand payload build (Aug 2026). */
(function () {
  'use strict';

  var cache = Object.create(null);

  function fetchHtml(url) {
    if (!url) return Promise.reject(new Error('Missing menu source'));
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Menu HTTP ' + response.status);
          return response.json();
        })
        .then(function (data) { return data && typeof data.html === 'string' ? data.html : ''; });
    }
    return cache[url];
  }

  async function hydrate(target, source) {
    if (target.dataset.ptmLoaded === 'true' || target.childElementCount) return true;
    source = source || target.getAttribute('data-ptm-source');
    try {
      var html = await fetchHtml(source);
      if (!html) throw new Error('Empty menu payload');
      target.innerHTML = html;
      target.dataset.ptmLoaded = 'true';
      return true;
    } catch (error) {
      target.innerHTML = '<p class="atp-ptm-load-error">Menu could not be loaded. <a href="/collections/all">Browse all parts</a>.</p>';
      target.hidden = false;
      return false;
    }
  }

  function initDesktop() {
    var triggers = document.querySelectorAll('[data-ptm-open]');
    if (!triggers.length) return;
    var flyouts = { a: document.getElementById('atp-ptm-flyout-a'), b: document.getElementById('atp-ptm-flyout-b') };
    var current = null;

    /* Portal + fixed positioning: the flyout lives on <body>, immune to any
       overflow/stacking context in the header (the "only shows after you
       scroll" bug was ancestor clipping that the sticky-header state happened
       to release). Position is computed from the trigger + header container. */
    function place(fly, trigger) {
      if (fly.parentNode !== document.body) document.body.appendChild(fly);
      /* v3.5: full-viewport span like the engine flyout (16px gutters). */
      var t = trigger.getBoundingClientRect();
      var width = window.innerWidth - 32;
      var left = 16;
      fly.style.left = left + 'px';
      fly.style.width = width + 'px';
      fly.style.top = Math.round(t.bottom + 4) + 'px';
    }

    function closeAll() {
      Object.keys(flyouts).forEach(function (k) { if (flyouts[k]) flyouts[k].hidden = true; });
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      current = null;
    }
    window.atpPtmCloseAll = closeAll;

    triggers.forEach(function (btn) {
      var which = btn.getAttribute('data-ptm-open');
      var fly = flyouts[which];
      if (!fly) return;
      btn.addEventListener('click', async function (e) {
        e.preventDefault();
        var wasOpen = !fly.hidden;
        closeAll();
        if (wasOpen) return;
        btn.setAttribute('aria-busy', 'true');
        var ok = await hydrate(fly, btn.getAttribute('data-ptm-source'));
        btn.removeAttribute('aria-busy');
        if (!ok) return;
        place(fly, btn);
        fly.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        current = { fly: fly, btn: btn };
      });
      /* global collection search (header bar): >=2 chars shows a cross-system
         results panel; clearing restores the previously active panel. */
      fly.addEventListener('input', function (e) {
        if (!e.target.matches('[data-ptm-gsearch]')) return;
        var q = e.target.value.trim().toLowerCase();
        var res = fly.querySelector('[data-ptm-gresults]');
        var list = fly.querySelector('[data-ptm-glist]');
        var count = fly.querySelector('[data-ptm-gcount]');
        var panels = fly.querySelectorAll('.atp-ptm-main-wrap > [data-ptm-panel]');
        if (!res || !list) return;
        if (q.length < 2) {
          res.hidden = true;
          var active = fly.querySelector('.atp-ptm-rail button.is-active');
          var key = active && (active.getAttribute('data-ptm-sys') || active.getAttribute('data-ptm-brand'));
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-ptm-panel') !== key; });
          return;
        }
        var html = '';
        var n = 0;
        fly.querySelectorAll('.atp-ptm-panel:not(.atp-ptm-gresults) .atp-ptm-list a').forEach(function (a) {
          if (a.textContent.toLowerCase().indexOf(q) !== -1) { html += a.outerHTML; n++; }
        });
        list.innerHTML = html || '<p style="padding:10px 4px;color:#8a97b5;font-size:13px;">No collections match.</p>';
        if (count) count.textContent = n + ' matching collection' + (n === 1 ? '' : 's');
        panels.forEach(function (p) { p.hidden = true; });
        res.hidden = false;
      });
      fly.addEventListener('click', function (e) {
        var bb = e.target.closest('[data-ptm-bsys]');
        if (bb) {
          var scope = bb.closest('.atp-ptm-panel');
          var key = bb.getAttribute('data-ptm-bsys');
          scope.querySelectorAll('.atp-ptm-brail button').forEach(function (x) { x.classList.toggle('is-active', x === bb); });
          scope.querySelectorAll('[data-ptm-bpanel]').forEach(function (p) { p.hidden = p.getAttribute('data-ptm-bpanel') !== key; });
          return;
        }
        if (e.target.closest('[data-ptm-close]')) { closeAll(); return; }
        var rb = e.target.closest('[data-ptm-sys],[data-ptm-brand]');
        if (!rb) return;
        var k = rb.getAttribute('data-ptm-sys') || rb.getAttribute('data-ptm-brand');
        fly.querySelectorAll('.atp-ptm-rail > button').forEach(function (x) { x.classList.toggle('is-active', x === rb); });
        fly.querySelectorAll('.atp-ptm-main-wrap > [data-ptm-panel]').forEach(function (p) {
          var on = p.getAttribute('data-ptm-panel') === k;
          p.hidden = !on;
          if (on) {
            var h = fly.querySelector('[data-ptm-heading]');
            if (h) h.textContent = p.getAttribute('data-ptm-label') || rb.textContent;
          }
        });
      });
    });

    window.addEventListener('resize', function () { if (current) place(current.fly, current.btn); });
    window.addEventListener('scroll', function () { if (current) closeAll(); }, { passive: true });

    document.addEventListener('click', function (e) {
      if (!current || !current.fly.isConnected) return;
      if (e.target.closest('.atp-ptm-flyout,[data-ptm-open]')) return;
      closeAll();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }

  function initMobile() {
    /* v3.6: pure document-level delegation. The theme rebuilds the mobile
       drawer DOM from a template on first open (common.js drawer stamping),
       destroying any nodes we bound listeners to at load — the reason the
       two menus would not open on phones. Delegation survives any rebuild. */
    if (initMobile.wired) return;
    initMobile.wired = true;
    document.addEventListener('click', async function (e) {
      if (e.target.closest('[data-ptm-filter]')) return;

      var toggle = e.target.closest('.atp-ptm-mobile-toggle');
      if (toggle) {
        var box = toggle.closest('[data-ptm-mobile]');
        var panel = box && box.querySelector('.atp-ptm-mobile-panel');
        if (!panel) return;
        var opening = panel.hidden;
        if (opening && !panel.childElementCount) {
          toggle.setAttribute('aria-busy', 'true');
          var ok = await hydrate(panel, box.getAttribute('data-ptm-source'));
          toggle.removeAttribute('aria-busy');
          if (!ok) return;
        }
        panel.hidden = !opening;
        toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
        return;
      }

      var sb = e.target.closest('.atp-ptm-msys');
      if (sb) {
        var wrap = sb.closest('.atp-ptm-mobile-links');
        var links = sb.nextElementSibling;
        var opening2 = links.hidden;
        wrap.querySelectorAll('.atp-ptm-mlinks').forEach(function (x) { x.hidden = true; });
        wrap.querySelectorAll('.atp-ptm-msys').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
        if (opening2) { links.hidden = false; sb.setAttribute('aria-expanded', 'true'); }
        return;
      }

      var sysBtn = e.target.closest('.atp-ptm-mobile-sys > button');
      if (sysBtn) {
        var pnl = sysBtn.closest('.atp-ptm-mobile-panel');
        var links2 = sysBtn.nextElementSibling;
        var opening3 = links2.hidden;
        pnl.querySelectorAll('.atp-ptm-mobile-links').forEach(function (x) { x.hidden = true; });
        pnl.querySelectorAll('.atp-ptm-mobile-sys > button').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
        if (opening3) { links2.hidden = false; sysBtn.setAttribute('aria-expanded', 'true'); }
      }
    });
  }

  /* one filter handler for everything: desktop panels and mobile accordions */
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-ptm-filter]')) return;
    var q = e.target.value.trim().toLowerCase();
    var scope = e.target.parentElement.querySelector('.atp-ptm-list') || e.target.parentElement;
    scope.querySelectorAll('a:not(.atp-ptm-viewall)').forEach(function (a) {
      a.hidden = q !== '' && a.textContent.toLowerCase().indexOf(q) === -1;
    });
  });

  function init() {
    /* isolated: a failure in any menu feature can never propagate to other
       scripts on the page (gallery, theme JS, apps). */
    try { initDesktop(); } catch (e) {}
    try { initMobile(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
